import React, { useState, useEffect } from 'react';
import { uploadPdf, getCoursePdfs, deletePdf } from '../services/api';
import toast from 'react-hot-toast';
import './PdfAttachments.css';

export default function PdfAttachments({ courseId, lessonIndex, isOwner }) {
  const [pdfs, setPdfs]           = useState([]);
  const [loading, setLoading]     = useState(true);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress]   = useState(0);
  const [file, setFile]           = useState(null);
  const [fileName, setFileName]   = useState('');
  const [showForm, setShowForm]   = useState(false);

  const load = () => {
    if (!courseId) return;
    setLoading(true);
    getCoursePdfs(courseId, lessonIndex)
      .then(r => setPdfs(r.data || []))
      .catch(() => setPdfs([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [courseId, lessonIndex]); // eslint-disable-line

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return toast.error('اختر ملف PDF أولاً');
    setUploading(true); setProgress(0);
    try {
      const fd = new FormData();
      fd.append('pdf', file);
      fd.append('courseId', courseId);
      if (lessonIndex !== undefined) fd.append('lessonIndex', lessonIndex);
      fd.append('fileName', fileName || file.name);
      await uploadPdf(fd, setProgress);
      toast.success('تم رفع الملف ✅');
      setFile(null); setFileName(''); setShowForm(false);
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || 'فشل الرفع');
    } finally { setUploading(false); setProgress(0); }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`حذف "${name}" نهائياً؟`)) return;
    try {
      await deletePdf(id);
      toast.success('تم الحذف');
      setPdfs(prev => prev.filter(p => p.id !== id));
    } catch { toast.error('فشل الحذف'); }
  };

  if (loading) {
    return (
      <div className="pdf-attachments">
        <div className="pdf-loading"><div className="spinner" style={{ width: 22, height: 22, borderWidth: 2 }} /></div>
      </div>
    );
  }

  return (
    <div className="pdf-attachments">
      <div className="pdf-header">
        <h4 className="pdf-title">
          📎 ملفات الدرس
          {pdfs.length > 0 && <span className="pdf-count">{pdfs.length}</span>}
        </h4>
        {isOwner && (
          <button className="btn btn-outline btn-sm" onClick={() => setShowForm(f => !f)}>
            {showForm ? '✕ إلغاء' : '+ رفع ملف'}
          </button>
        )}
      </div>

      {isOwner && showForm && (
        <form onSubmit={handleUpload} className="pdf-upload-form">
          <div className="form-group">
            <label className="form-label">اسم الملف (اختياري)</label>
            <input className="form-input" placeholder="مثال: شرح الوحدة الأولى"
              value={fileName} onChange={e => setFileName(e.target.value)} />
          </div>
          <label className="pdf-file-label">
            {file ? `📄 ${file.name}` : '📁 اختر ملف PDF (حتى 20MB)'}
            <input type="file" accept=".pdf,application/pdf"
              onChange={e => setFile(e.target.files[0])} style={{ display: 'none' }} />
          </label>
          {uploading && (
            <div className="pdf-prog-wrap">
              <div className="pdf-prog-bar" style={{ width: `${progress}%` }} />
              <span>{progress}%</span>
            </div>
          )}
          <button type="submit" className="btn btn-primary btn-sm" disabled={uploading || !file}>
            {uploading ? 'جارٍ الرفع...' : 'رفع الملف'}
          </button>
        </form>
      )}

      {pdfs.length === 0 ? (
        <p className="pdf-empty">لا توجد ملفات مرفقة بهذا الدرس.</p>
      ) : (
        <div className="pdf-list">
          {pdfs.map(p => (
            <div key={p.id} className="pdf-item">
              <span className="pdf-item-icon">📄</span>
              <div className="pdf-item-info">
                <span className="pdf-item-name">{p.fileName}</span>
                {p.size && <span className="pdf-item-size">{(p.size / 1024).toFixed(0)} KB</span>}
              </div>
              <div className="pdf-item-actions">
                <a href={p.fileURL} target="_blank" rel="noreferrer"
                  className="btn btn-primary btn-sm" download>
                  تحميل
                </a>
                {isOwner && (
                  <button className="btn btn-sm pdf-del-btn"
                    onClick={() => handleDelete(p.id, p.fileName)}>
                    حذف
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
